<app-header></app-header>
<app-otp-auth [showOtpForm]="otpVerifyInProgress" [phoneNumber]="phoneNumber" (onOtpVerified)="onOtpVerified($event)"></app-otp-auth>
